import { useSelector } from 'react-redux';

import { generateOfficialSiteURL } from 'reduxModules/navigation/selector';

export default function useGetOfficialSiteURL() {
  const getOfficialSiteURL = useSelector(generateOfficialSiteURL);
  return getOfficialSiteURL;
}
